import React from 'react'
import axios from 'axios'
import { Link, withRouter } from 'react-router-dom'
import { Menu, Select, Icon, Tooltip } from 'antd'

import apiPath from 'apiPath'
import stickyError from 'components/stickyError'

import './Sidebar.css'

class MenuTitle extends React.Component {
	render() {
		const { itemKey, title } = this.props
		const status =
			typeof this.props.status === 'function'
				? this.props.status()
				: this.props.status
		return (
			<Link to={'/portal/' + itemKey}>
				{status === 'done' && (
					<Icon
						type='check-circle'
						style={{ color: 'green', fontWeight: 'normal' }}
					/>
				)}
				{status === 'warning' && (
					<Icon
						type='exclamation-circle'
						style={{ color: 'orange', fontWeight: 'normal' }}
					/>
				)}
				{status === 'required' && (
					<Icon
						type='exclamation-circle'
						style={{ color: 'red', fontWeight: 'normal' }}
					/>
				)}
				{status === 'soon' && (
					<Icon
						type='clock-circle'
						style={{ color: 'lightblue', fontWeight: 'normal' }}
					/>
				)}
				<span>{title}</span>
			</Link>
		)
	}
}

class VoyageSelect extends React.Component {
	state = {
		currentVoyageId: null,
	}

	getEventFromProps = (props) => {
		if (!props.booking.EventId) return

		this.setState({ currentVoyageId: props.booking.EventId })
	}

	handleChange = (value) => {
		axios
			.get(apiPath + '/booking/switchevent/' + value, {
				withCredentials: true,
			})
			.then((response) => {
				this.setState({ voyage: value })
				this.props.refreshBooking()
				this.props.refreshStatuses()
				this.props.voyages.find((voyage) => voyage.id === value)
			})
			.catch((error) => {
				const voyageName = this.props.voyages.find(
					(voyage) => voyage.id === value
				).name

				stickyError(
					'No booking found for the ' + voyageName + ' voyage'
				)

				console.error(error)
			})
	}

	componentDidMount() {
		this.getEventFromProps(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.getEventFromProps(nextProps)
	}

	render() {
		return (
			<Select
				style={{ minWidth: '170px' }}
				value={this.state.currentVoyageId}
				onChange={this.handleChange}
			>
				{this.props.voyages &&
					this.props.voyages.map((voyage) => {
						return (
							<Select.Option key={voyage.id}>
								{voyage.name}
							</Select.Option>
						)
					})}
			</Select>
		)
	}
}

class Sidebar extends React.Component {
	state = {
		current: null,
		openKeys: [],
		showMoreSections: false,
	}

	handleClick = (event) => {
		this.setState({ current: event.key })
	}

	handleOpenChange = (openKeys) => {
		const state = this.state
		const latestOpenKey = openKeys.find(
			(key) => !(state.openKeys.indexOf(key) > -1)
		)
		const latestCloseKey = state.openKeys.find(
			(key) => !(openKeys.indexOf(key) > -1)
		)

		let nextOpenKeys = []
		if (latestOpenKey) {
			nextOpenKeys = [latestOpenKey]
		}
		if (latestCloseKey) {
			nextOpenKeys = []
		}
		let s = {}
		s.openKeys = nextOpenKeys
		this.setState(s)
	}
	setStateFromProps = (props) => {
		let s = {}
		s.openKeys = [props.location.pathname.split('/')[2]]
		if (props.location.pathname.split('/').length > 2)
			s.current = props.location.pathname.split('/')[3]
		this.setState(s)
	}

	toggleMoreSections = () =>
		this.setState({ showMoreSections: !this.state.showMoreSections })

	componentWillMount() {
		this.setStateFromProps(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.setStateFromProps(nextProps)
	}
	render() {
		const current = this.state.current || this.state.openKeys[0]
		return (
			<div id='sidebar'>
				<Menu
					mode='inline'
					openKeys={this.state.openKeys}
					selectedKeys={[current]}
					onOpenChange={this.handleOpenChange}
					onClick={this.handleClick}
				>
					<Menu.ItemGroup
						title={
							<span>
								Voyage:{' '}
								<VoyageSelect
									voyages={this.props.voyages}
									booking={this.props.booking}
									refreshBooking={this.props.refreshBooking}
									refreshStatuses={this.props.refreshStatuses}
								/>
							</span>
						}
					>
						{this.props.menuItems.map((item) => {
							if (!item.children || item.children.length === 0) {
								if (item.visible !== true) return null
								return (
									<Menu.Item key={item.key.toLowerCase()}>
										<MenuTitle
											itemKey={item.key.toLowerCase()}
											title={item.titleText}
											status={item.status}
										/>
									</Menu.Item>
								)
							}
							const visibleChildren = item.children.filter(
								(subitem) => subitem.visible === true
							)
							if (visibleChildren.length === 0) {
								return null
							}
							const newTitle =
								typeof item.titleText === 'string'
									? item.titleText
									: typeof item.titleText === 'function'
									? item.titleText()
									: ''
							return (
								<Menu.SubMenu
									key={item.key.toLowerCase()}
									title={
										<MenuTitle
											itemKey={item.key.toLowerCase()}
											title={newTitle}
											status={item.status}
										/>
									}
								>
									{visibleChildren.map((subitem) => {
										if (
											typeof subitem.hideIf ===
												'function' &&
											subitem.hideIf() !== false
										) {
											return null
										}
										if (
											typeof subitem.requiredIf ===
												'function' &&
											subitem.requiredIf() !== false
										) {
											return (
												<Menu.Item key={subitem.label}>
													<Link
														to={
															'/portal/' +
															item.key.toLowerCase() +
															'/' +
															subitem.label
														}
													>
														<Icon
															type='exclamation-circle'
															style={{
																color: 'red',
																fontWeight:
																	'normal',
																marginLeft:
																	'-16pt',
															}}
														/>
														{subitem.label}
													</Link>
												</Menu.Item>
											)
										} else if (
											typeof subitem.blockIf ===
												'function' &&
											subitem.blockIf() !== false
										) {
											return (
												<Menu.Item
													key={subitem.label}
													className='partiallyDisabled'
												>
													<Tooltip
														placement='top'
														title={subitem.blockIf()}
													>
														<Link
															to={
																'/portal/' +
																item.key.toLowerCase() +
																'/' +
																subitem.label
															}
														>
															{subitem.label}
														</Link>
													</Tooltip>
												</Menu.Item>
											)
										} else {
											return (
												<Menu.Item key={subitem.label}>
													<Link
														to={
															'/portal/' +
															item.key.toLowerCase() +
															'/' +
															subitem.label
														}
													>
														{subitem.label}
													</Link>
												</Menu.Item>
											)
										}
									})}
								</Menu.SubMenu>
							)
						})}
					</Menu.ItemGroup>
				</Menu>
			</div>
		)
	}
}

export default withRouter(Sidebar)



// WEBPACK FOOTER //
// ./portal-components/Sidebar/index.jsx